<script setup lang="ts">
import {ref} from "vue";
import {ExtendedProject, User} from "@/types";
import LeftNavigationDrawer from "@/layouts/components/LeftNavigationDrawer.vue";
import NavigationBar from "@/layouts/components/NavigationBar.vue";
import RightNavigationDrawer from "@/layouts/components/RightNavigationDrawer.vue";
import {useDisplay} from "vuetify";
import SearchDialog from "@/layouts/components/SearchDialog.vue";
import * as Sentry from "@sentry/vue";

interface Props {
    title: string,
    user: User,
    project?: ExtendedProject,
}

const props = withDefaults(defineProps<Props>(), {
    project: undefined,
})

const {lgAndDown} = useDisplay()
const showMenu = ref(false)
const showUserMenu = ref(false)
const isSearchDialogOpen = ref(false)

const menuItems = [
    {
        label: 'Home',
        icon: 'mdi-home-outline',
        route: 'dashboard'
    }
]

Sentry.setUser({
    fullName: props.user.full_name,
    email: props.user.email,
})
</script>

<template>
    <v-app class="system-font">
        <left-navigation-drawer
            v-model="showMenu"
            :items="menuItems"
        />

        <right-navigation-drawer
            v-model="showUserMenu"
            :user="user"
        />

        <navigation-bar
            :user="props.user"
            :title="props.title"
            :project="props.project"
            @show-menu="showMenu = true"
            @show-user-menu="showUserMenu = true"
            @show-search="isSearchDialogOpen = true"
        />
        <v-main>
            <v-container
                class="pa-0"
                :fluid="lgAndDown"
            >
                <slot />
            </v-container>
        </v-main>
        <search-dialog v-model="isSearchDialogOpen" />
    </v-app>
</template>

<style scoped>
@media (min-width: 1920px) {
    .v-container {
        max-width: 1280px;
    }
}
</style>
